import _filter from 'lodash/filter';

export const currencySign = (str) => {
  return (str !== undefined) ? str.charAt(0) : "";
}

export function arraysEqual(arr1, arr2) {
    if(arr1.length !== arr2.length)
        return false;
    for(var i = arr1.length; i--;) {
        if(arr1[i] !== arr2[i])
            return false;
    }
    return true;
}


export function stopPass(currentISO, arr){
  for(var i = 0; i < arr.length; i++){
    if(arr[i] === currentISO){
      return true;
    }
  }
}

export function historyPushState(filterKey1, filterProperty1, query){

  let newurl = "";
  if(query === undefined){
     newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1;
  }else{
    if(query.utm_source && query.utm_campaign && query.utm_medium){
     newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1+
     '&utm_source='+query.utm_source+'&utm_campaign='+query.utm_campaign+"&utm_medium="+query.utm_medium;
   }else{
      newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1;
   }
  }

  if (window.history.pushState) {
      window.history.pushState({path:newurl},'',newurl);
  }
}

export function isInt(value) {
  return !isNaN(value) && parseInt(Number(value),10) === value && !isNaN(parseInt(value, 10));
}

export function ieCheck(){
    //Checks IE 6 - 11 and Edge
    const ua = window.navigator.userAgent;
    return (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) ? true : false;
}


//Scroll to element
export function scrollTo(element) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
  });
}


//Update url paramater
export function updateUrlParameter(param, value) {
  const regExp = new RegExp(param + "(.+?)(&|$)", "g");
  const newUrl = window.location.href.replace(regExp, param + "=" + value + "$2");
  window.history.pushState("", "", newUrl);
}


//Product title for fixed and hoho tours
export function renderProductTitle(product, selectedTourId){
  if(product !== undefined && product.header.product_options !== undefined && product.header.product_options.length > 0){
    const tourName = _filter(product.header.product_options, {'tour_id': selectedTourId})[0];
    return (tourName !== undefined) ? tourName.name : "";
  }else{
    return product.header.name;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js